module.exports = __webpack_public_path__ + "img/andreea-flash-sale.8f25c9c0.png";